import React from "react";
import PropTypes from "prop-types";
import { Card, CardHeader, CardContent, Typography } from "@material-ui/core";

const Release = props => {
  if (props.showVersion && props.version !== props.showVersion) return null;
  const bugs = props.children.filter(child => child.props.type === "bug");
  const features = props.children.filter(
    child =>
      child.props.type === "feature" || child.props.type === "new feature"
  );
  const improvements = props.children.filter(
    child => child.props.type === "improvement"
  );
  const tasks = props.children.filter(child => child.props.type === "task");

  return (
    <div style={{ marginBottom: "20px" }}>
      <Card>
        <CardHeader
          title={`${props.date}  - Version ${props.version}`}
          style={{ backgroundColor: "rgb(232, 232, 232)" }}
        />
        <CardContent>
          <Typography variant="h5">
            <b>{props.heading}</b>
          </Typography>
          <br />
          {features.length > 0 && (
            <div>
              <Typography variant="h6">
                Features
                <span
                  role="img"
                  style={{ fontSize: "30px" }}
                  aria-label="crane"
                >
                  🏗️
                </span>
              </Typography>
              <ul>{features}</ul>
            </div>
          )}
          {improvements.length > 0 && (
            <div>
              <Typography variant="h6">
                Improvements{" "}
                <span
                  role="img"
                  style={{ fontSize: "30px" }}
                  aria-label="chart"
                >
                  📈
                </span>
              </Typography>
              <ul>{improvements}</ul>
            </div>
          )}
          {bugs.length > 0 && (
            <div>
              <Typography variant="h6">
                Bug Fixes
                <span role="img" style={{ fontSize: "30px" }} aria-label="bug">
                  🐛
                </span>
              </Typography>
              <ul>{bugs}</ul>
            </div>
          )}

          {tasks.length > 0 && (
            <div>
              <Typography variant="h6">
                Tasks{" "}
                <span
                  role="img"
                  style={{ fontSize: "30px" }}
                  aria-label="checkbox"
                >
                  ☑️
                </span>
              </Typography>
              <ul>{tasks}</ul>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

Release.propTypes = {
  heading: PropTypes.string,
  date: PropTypes.string,
  version: PropTypes.string.isRequired,
  showVersion: PropTypes.string,
  children: PropTypes.arrayOf(PropTypes.node).isRequired
};
Release.defaultProps = {
  showVersion: null,
  heading: "",
  date: ""
};

const Issue = props => (
  <li style={{ marginBottom: "10px" }}>
    <div style={{ marginBottom: "5px" }}>
      <Typography variant="subtitle1">{props.title}</Typography>
    </div>
    <div>
      <Typography variant="body2">{props.children}</Typography>
    </div>
  </li>
);
Issue.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};

export { Release, Issue };
